import React, {
  ReactElement, ReactNode, useCallback, useMemo,
} from 'react';
import Context, { StadiumMaterialuHistoriaContextContent } from './StadiumMaterialuHistoriaContext';
import { useClient } from '../ClientStatusContext';
import { getStadiumMaterialuHistoria } from '../../client/external/stadiumMaterialuHistoriaClient';

interface Props {
  children: ReactNode;
}

const StadiumMaterialuHistoriaContextProvider = ({ children }: Props): ReactElement => {
  const { wrapClient, status, data } = useClient(getStadiumMaterialuHistoria);
  const fetchStadiumHistoria = useCallback(
    (uuid): void => { wrapClient(uuid); },
    [wrapClient],
  );

  const value: StadiumMaterialuHistoriaContextContent = useMemo(() => ({
    stadiumMaterialuHistoria: data || undefined,
    stadiumMaterialuHistoriaStatus: status,
    fetchStadiumHistoria,
  }), [fetchStadiumHistoria, data, status]);

  return (
    <Context.Provider value={value}>
      {children}
    </Context.Provider>
  );
};

export default StadiumMaterialuHistoriaContextProvider;
